import styled from 'styled-components';

import { Theme } from '@/styles/themes/types';

export type InfoBoxType = 'info' | 'warning' | 'danger';

const InfoTypes = {
	INFO: 'info',
	WARNING: 'warning',
	DANGER: 'danger',
} as const;

type InfoBoxBackgrounColor = {
	type: InfoBoxType;
	theme: Theme;
}

function getBackgroundColor({ type, theme }: InfoBoxBackgrounColor) {
	if (type === InfoTypes.INFO) {
		return theme.palette.primary['100'];
	}

	if (type === InfoTypes.WARNING) {
		return theme.palette.risk.moderate[100];
	}

	return theme.colors.danger;
}

function getSVgColor({ type, theme }: InfoBoxBackgrounColor) {
	if (type === InfoTypes.INFO) {
		return theme.palette.primary.default;
	}

	if (type === InfoTypes.WARNING) {
		return theme.palette.risk.moderate.default;
	}

	return theme.colors.danger;
}

export const Container = styled.div<{ type: InfoBoxType }>`
	background-color: ${({ theme, type }) => getBackgroundColor({ type, theme })};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	padding: 1rem;
	display: flex;
	align-items: center;
	color: ${({ theme, type }) => (type === 'danger' ? theme.palette.secondary.white : theme.palette.secondary['400'])};

	svg {
		color: ${({ theme, type }) => getSVgColor({ type, theme })};
		margin-right: 0.5rem;
	}
`;
